import { IconChevronRight, IconFilePlus, IconSearch } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Banner, EmptyState, Spinner } from '@/components/common';
import { useResource } from '@/hooks';
import { errorMessage } from '@/lib/api-client';
import { navigate } from '@/lib/router';
import { formatDate, formatRsd } from '../chart/components';
import { offersApi } from './api';

/** Issued offers, newest first: search by number or patient, open to reprint or correct. */
export function OffersPage() {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');
  const [debounced, setDebounced] = useState('');
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(query.trim()), 250);
    return () => clearTimeout(timer);
  }, [query]);
  const offers = useResource(() => offersApi.list(debounced), debounced);

  return (
    <div className="stack">
      <div className="page-head">
        <div className="page-head__title">
          <h1>{t('offers.title')}</h1>
        </div>
        <button
          type="button"
          className="btn btn--sm btn--primary"
          onClick={() => navigate({ name: 'offer', id: 'new' })}
        >
          <IconFilePlus size={18} /> {t('offers.new')}
        </button>
      </div>

      <div className="search">
        <IconSearch size={20} />
        <input
          className="input"
          type="search"
          placeholder={t('offers.searchPlaceholder')}
          aria-label={t('offers.searchPlaceholder')}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>

      {offers.error ? (
        <Banner
          tone="error"
          action={
            <button type="button" className="btn btn--sm" onClick={() => offers.reload()}>
              {t('common.retry')}
            </button>
          }
        >
          {errorMessage(offers.error)}
        </Banner>
      ) : !offers.data ? (
        <Spinner />
      ) : offers.data.length === 0 ? (
        <EmptyState>{debounced ? t('offers.noResults') : t('offers.empty')}</EmptyState>
      ) : (
        <section className="card" style={{ padding: '4px 12px' }}>
          <ul className="list">
            {offers.data.map((o) => (
              <li key={o.id}>
                <button
                  type="button"
                  className="list-item"
                  onClick={() => navigate({ name: 'offer', id: o.id })}
                >
                  <span className="offer-number">{o.number}</span>
                  <span className="grow">
                    <strong>{o.patientName}</strong>
                    <span className="small muted" style={{ display: 'block' }}>
                      {formatDate(o.issuedAt)} · {formatRsd(o.totalRsd)}
                    </span>
                  </span>
                  <IconChevronRight size={20} className="muted" />
                </button>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}
